// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__M-e59","disabled":"FileBtn_disabled__3k0F9","warn":"FileBtn_warn__2OQbw","fade":"FileBtn_fade__DQN8b"};